// 會員站所有「營隊」相關 route name。
// FloatingBtn（一般課程官方連結，這些頁面要隱藏）與 CampFloatingBtn（營隊官方 LINE 詢問，只在這些頁面顯示）
// 共用同一份清單，避免各自維護造成漏掉新頁面（例如營隊訂單、匯款回報等會員中心頁）。
export const CAMP_ROUTE_NAMES = [
    'Camps',
    'CampOverview',
    'CampPrograms',
    'CampProgram',
    'CampCart',
    'CampCheckout',
    'CampRegistrationComplete',
    'CampRegistration',
    'CampOrder',
    'CampOrderDetail',
    'CampPaymentReport',
    'CampCoupon',
    'CampFavorite',
    'CampRelations',
    'CampRelationForm',
    'CampRelationEdit',
    // 會員通知中心第一階段僅支援 Camp，之後若擴及一般課程需另外調整此清單。
    'MemberNotification',
    'MemberNotificationDetail',
];
